
const LeftSide = ({ selectedProject, apartment, rooms }) => {
  return (
    <>
      <ul className="hidden border-b-2 border-t-2 border-primary-dark/30 row-span-2 row-start-1 col-span-4 col-start-1 xl:flex items-center justify-normal gap-4 list-none">
        <li
          className={`text-2xl text-primary-bg-blue py-4 flex items-center justify-center gap-2`}
        >
          <span className="tracking-normal">
            Ap. <strong className="tracking-wider ">{apartment.number}</strong>
          </span>
        </li>
      </ul>

      <div className="hidden row-start-3 col-span-full xl:col-span-4 xl:col-start-1 pt-8 xl:flex flex-col gap-6 justify-start items-start ">
        <div className="w-full flex flex-col items-start justify-between gap-4 text-primary-dark pb-8 border-b-2 border-primary-dark/30">
          <span className="text-xl">
            სართული <strong>{apartment.floorNumber}</strong>
          </span>
          <div className="flex flex-col items-start justify-between gap-2">
            <span>მ სიმაღლის ნიშნული</span>
            <span>
              ჩაბარების პირობა:{" "}
              <strong className="text-primary-orange tracking-wider">
                {selectedProject.name === "nikea"? "მწვანე კარკასი" : "თეთრი კარკასი"}
              </strong>
            </span>
          </div>
        </div>
        <ul className=" text-primary-bg-blue w-full px-8">
          {rooms &&
            rooms.length > 0 &&
            rooms.map((room, index) => {
              return (
                <div key={index} className={`w-full  grid grid-cols-10`}>
                  <div
                    className={`col-span-1 flex items-center justify-center col-start-1  bg-primary-orange text-primary-light py-3 text-lg font-semibold ${
                      index === 0
                        ? "rounded-t-full"
                        : index === rooms.length - 1
                        ? "rounded-b-full"
                        : ""
                    }`}
                  >
                    {index + 1}
                  </div>
                  <div
                    className={`col-span-8 flex items-center justify-start col-start-3 text-xl`}
                  >
                    <span>{room.label}</span>/
                    <strong>
                      {room.size}m<sup data-v-418ea57b="">2</sup>
                    </strong>
                  </div>
                </div>
              );
            })}
        </ul>
      </div>
    </>
  );
};

export default LeftSide;
